import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Assistant welcome message component.
 * Displays the welcome message with fallback to default text.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters containing welcome message
 * @returns {JSX.Element}
 */
export default function WelcomeMessage({ parameters }) {
  const { t } = useLanguage()

  return (
    <div className="welcomeLineDiv welcomeMessage">
      <span id="welcomeMessage">{parameters.welcomeMessage || t("Text.textHomeInput")}</span>
    </div>
  )
}
